// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import FormattedNumberInput from '../../../../shared/components/formatted-number-input';
import SpecialAllowancePartialDebit from '@deere/cps-it.warranty-model-factory/lib/special-allowance-partial-debit';
import {getAmountWithCurrency} from '../../services/partial-debit-helper';

const existingTotalContribution = debit => debit.companyContribution + debit.customerContribution + debit.dealerContribution;

const newTotalContribution = debit => debit.changedCompanyContribution + debit.customerContribution + debit.dealerContribution;

function handleCompanyContributionChange(value) {

    this.actions.updateCompanyContribution(value);

}

const DebitSpecialAllowancePanel = props =>
    <section className='debit-special-allowance-panel'>
        <header className='title'>
            <FormattedMessage id='SPECIAL_ALLOWANCE_CONTRIBUTIONS'/>
        </header>
        <div className='row header'>
            <div className='description'>
                <FormattedMessage id='DESCRIPTION'/>
            </div>
            <div className='amount'>
                <FormattedMessage id='AMOUNT'/>
            </div>
            <div className='new-value'>
                <FormattedMessage id='NEW_VALUE'/>
            </div>
        </div>
        <div className='row'>
            <div className='description'>
                <FormattedMessage id='CUSTOMER_CONTRIBUTION'/>
            </div>
            <div className='amount'>
                <span>{getAmountWithCurrency(props.specialAllowancePartialDebit.customerContribution, props.specialAllowancePartialDebit.currency)}</span>
            </div>
            <div className='new-value'>
                <span>
                </span>
            </div>
        </div>
        <div className='row'>
            <div className='description'>
                <FormattedMessage id='DEALER_CONTRIBUTION'/>
            </div>
            <div className='amount'>
                <span>{getAmountWithCurrency(props.specialAllowancePartialDebit.dealerContribution, props.specialAllowancePartialDebit.currency)}</span>
            </div>
            <div className='new-value'>
                <span>
                </span>
            </div>
        </div>
        <div className='row'>
            <div className='description'>
                <FormattedMessage id='COMPANY_CONTRIBUTION'/>
            </div>
            <div className='amount'>
                <span>{getAmountWithCurrency(props.specialAllowancePartialDebit.companyContribution, props.specialAllowancePartialDebit.currency)}</span>
            </div>
            <div className='new-value'>
                <FormattedNumberInput
                    allowNegative={false}
                    className='changed-company-contribution'
                    decimalPrecision={2}
                    isValidInput={value => value < props.specialAllowancePartialDebit.companyContribution && value >= 0}
                    onValueChange={props::handleCompanyContributionChange}
                    value={props.specialAllowancePartialDebit.changedCompanyContribution}
                />
            </div>
        </div>
        <div className='row'>
            <div className='description'>
                <FormattedMessage id='TOTAL'/>
            </div>
            <div className='amount'>
                <span>{getAmountWithCurrency(existingTotalContribution(props.specialAllowancePartialDebit), props.specialAllowancePartialDebit.currency)}</span>
            </div>
            <div className='new-value'>
                <span>{getAmountWithCurrency(newTotalContribution(props.specialAllowancePartialDebit), props.specialAllowancePartialDebit.currency)}</span>
            </div>
        </div>
    </section>;

DebitSpecialAllowancePanel.displayName = 'DebitSpecialAllowancePanel';
DebitSpecialAllowancePanel.propTypes = {
    actions: PropTypes.object.isRequired,
    specialAllowancePartialDebit: PropTypes.instanceOf(SpecialAllowancePartialDebit).isRequired
};

export default DebitSpecialAllowancePanel;



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-special-allowance-panel/debit-special-allowance-panel.js